export const musaVoiceTestInstructionsConfig = [
  {
    sectionKey: "intro",
    task: "Introduction",
    parts: [
      {
        partKey: "main",
        textBlock:
          "Thank you for participating. The video tutorial provides information on this study.",
        videoUrl: "user_test/videos/intro.mp4",
        question:
          "How confident are you in your ability to complete the tasks in this study?",
      },
    ],
  },
  {
    sectionKey: "pitch_mod_no_tool",
    task: "Pitch Modulation Control No Tool",
    parts: [
      {
        partKey: "main",
        textBlock:
          "The following exercises are designed to test how useful you find practicing pitch modulation techniques, specifically whether you sing with or without vibrato. The video tutorial provides an example of how to complete this task.",
        videoUrl: "user_test/videos/pitch_mod_no_tool.mp4",
        question:
          "How confident are you in your ability to complete this task (in your ability to produce a distinct vibrato VS straight tone when asked)?",
      },
    ],
  },
  {
    sectionKey: "pitch_mod_tool",
    task: "Pitch Modulation Control Tool",
    parts: [
      {
        partKey: "main",
        textBlock:
          "The following exercises are designed to test how useful you find the feedback tool in its analysis of pitch modulation techniques, specifically whether you sing with or without vibrato. The video tutorial provides an example of how to complete this task.",
        videoUrl: "user_test/videos/pitch_mod_tool.mp4",
        question:
          "How confident are you in your ability to complete this task (in your ability to produce a distinct vibrato VS straight tone when asked)?",
      },
    ],
  },
  {
    sectionKey: "vocal_tone_no_tool",
    task: "Vocal Tone Control No Tool",
    parts: [
      {
        partKey: "main",
        textBlock:
          "The following exercises are designed to test how useful you find practising vocal tone shifting techniques, specifically whether you sing with a belting or breathy tone. The video tutorial provides an example of how to complete this task.",
        videoUrl: "user_test/videos/vocal_tone_no_tool.mp4",
        question:
          "How confident are you in your ability to complete this task (in your ability to produce a distinct belting VS breathy tone when asked)?",
      },
    ],
  },
  {
    sectionKey: "vocal_tone_tool",
    task: "Vocal Tone Control Tool",
    parts: [
      {
        partKey: "main",
        textBlock:
          "The following exercises are designed to test how useful you find the feedback tool in its analysis of vocal tone shifting techniques, specifically whether you sing with a belting or breathy tone. The video tutorial provides an example of how to complete this task.",
        videoUrl: "user_test/videos/vocal_tone_tool.mp4",
        question:
          "How confident are you in your ability to complete this task (in your ability to produce a distinct belting VS breathy tone when asked)?",
      },
    ],
  },
];
